import Home from '../Home/Home';
const MenuRoutes = [
  {
    title : "Home",
    path: "/",
    component: Home,
    className: "",
  }
];
export default MenuRoutes;